import React, { useCallback, useContext, useRef, useState } from "react";
import BreadCrumb from "../../components/BreadCrumb";
import Button from "../../components/Button";
import { FaSearch } from "react-icons/fa";
import { Formik, Form, ErrorMessage, FieldArray } from "formik";
import ImagePreview from "../../components/ImagePreview";
import TextInput from "../../components/TextInput";
import SidebarField from "../../components/Sidebar/SidebarField";
import LoaderContext from "../../components/loader";
import { FormField } from "../../components/FormField";
import Dropdown from "../../components/Dropdown";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { IoAddCircleOutline } from "react-icons/io5";
import ToggleField from "../../components/ToggleField";
import Tooltip from "../../components/Tooltip/Tooltip";
import { compressImage } from "../../custom/compressImage";
import { MultiSelect } from "primereact/multiselect";
import YtVideoCard from "./YtVideoCard";

const Resources = () => {
  const [isVisible, setVisible] = useState(false);
  const [currentItems, setCurrentItems] = useState("");
  const debounceTimeout = useRef(null);
  const [searchQuery, setSearchQuery] = useState("");
  const { handleLoading } = useContext(LoaderContext);
  const [croppedImageURL, setCroppedImageURL] = useState(null);

  const handleCroppedImage = (croppedBlob) => {
    // Convert blob to a URL for preview or upload
    const previewURL = URL.createObjectURL(croppedBlob);
    setCroppedImageURL(previewURL);
    console.log("Cropped image blob:", croppedBlob);
  };

  const handleFileUpload = (e, setFieldValue) => {
    const f = e.target.files[0];

    compressImage(f, (ci) => {
      setFieldValue("image", ci);
    });
  };

  const handleSubmit = async (values, { resetForm }) => {
    handleLoading(true);
    try {
      console.log("Form Values:", values);
      // Add logic to send data to API
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      handleLoading(false);
      resetForm();
      handleClose();
    }
  };

  const initialValues = {
    title: currentItems?.title || "",
    author: currentItems?.author || "",
    contentType: currentItems?.contentType || "",
    cashCropCategory: currentItems?.cashCropCategory || "",
    overview: currentItems?.overview || "",
    // mainContent: currentItems?.mainContent || "",
    image: currentItems?.image || "",
    // relatedResources: currentItems?.relatedResources || [],
    // downloadableMaterials: currentItems?.downloadableMaterials || [],
    targetAudience: currentItems?.targetAudience || [],
    // region: currentItems?.region || "",
    language: currentItems?.language || "",
    keywords: currentItems?.keywords || [],
    datePublished: currentItems?.datePublished || "",
    introVideoLink: currentItems?.introVideoLink || "",
    expertContact: currentItems?.expertContact || "",
    courseDetails: currentItems?.courseDetails || "",
    courseLevel: currentItems?.courseLevel || "",
    syllabusDetails: {
      courseDuration: currentItems?.syllabusDetails?.courseDuration || "",
      // courseLevel: currentItems?.syllabusDetails?.courseLevel || "",
      syllabus: currentItems?.syllabusDetails?.syllabus || [
        { title: "", duration: "", video: "", downloadableMaterials: "" }, // Updated structure for each syllabus lesson
      ],
      certification: currentItems?.courseDetails?.certification || false,
    },
  };

  const handleSearch = useCallback((s) => {
    // console.log('Search at OrderCom', s);
    setSearchQuery(s);
  }, []);

  const debouncedSearch = useCallback(
    (s) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = setTimeout(() => {
        handleSearch(s.target.value);
      }, 1500);
    },
    [handleSearch]
  );
  const handleOpen = (item) => {
    setCurrentItems();
    if (item) {
      setCurrentItems(item);
      //   setPreview(item?.image);
    }
    // setVisible(true);
  };

  const handleClose = () => {
    // setFile(null);
    // setPreview(null);
    setVisible(false);
    setCurrentItems();
    // setSubCategoryFields([]);
  };

  return (
    <div className="p-5 w-[100%] ">
      <div className="flex justify-between items-center flex-wrap mb-2">
        <BreadCrumb title="Category" />
      </div>
      <div className="flex justify-between mx-5 border-b pb-2">
        <div className="border border-[--color--1] rounded-full px-3 py-1.5 text-xs bg-transparent w-fit flex justify-between items-center">
          <input
            type="search"
            placeholder="search..."
            // value={searchQuery}
            onChange={debouncedSearch}
            className="bg-transparent outline-none"
          />
          <FaSearch className="text-[--color--1]" />
        </div>
        <Button
          text="Add New"
          type="button"
          className="float-end"
          onClick={() => {
            setVisible(true);
            setCurrentItems();
          }}
        />
      </div>
      <YtVideoCard />
      {/* <div className="grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-4">
        {categoryData?.categories?.map((item) => (
          <Card
            item={item}
            handleOpen={handleOpen}
            fetchingCategoryItems={fetchingCategoryItems}
            handleClose={handleClose}
          />
        ))}
      </div> */}
      {isVisible && (
        <Formik
          initialValues={initialValues}
          // validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({ values, handleChange, setFieldValue }) => (
            <Form className="w-full flex gap-0  flex-col bg-transparent py-5 px-3">
              <SidebarField
                handleClose={handleClose}
                title={
                  currentItems?.id ? "Update Resource" : "Add New Resource"
                }
                button1={
                  <Button text="Cancel" type="button" onClick={handleClose} />
                }
                button2={<Button text={currentItems?.id ? "Update" : "Add"} />}
              >
                {/* Title */}
                <FormField label="Title" tooltip="Enter the resource title">
                  <TextInput
                    name="title"
                    type="text"
                    placeholder="Enter resource title"
                    value={values.title}
                    onChange={handleChange}
                    className={"mb-4"}
                  />
                  <ErrorMessage
                    name="title"
                    component="div"
                    className="error"
                  />
                </FormField>

                {/* Author */}
                <FormField label="Author" tooltip="Enter the author's name">
                  <TextInput
                    name="author"
                    type="text"
                    placeholder="Enter author name"
                    value={values.author}
                    onChange={handleChange}
                    className={"mb-4"}
                  />
                  <ErrorMessage
                    name="author"
                    component="div"
                    className="error"
                  />
                </FormField>

                {/* Content Type */}
                <FormField
                  label="Content Type"
                  tooltip="Select type of content"
                >
                  <div id="contentType" className="mb-4">
                    <Dropdown
                      options={[
                        { label: "Article", value: "article" },
                        { label: "Guide", value: "guide" },
                        { label: "Manual", value: "manual" },
                        {
                          label: "Training Material",
                          value: "training_material",
                        },
                        { label: "Case Study", value: "case_study" },
                        { label: "Best Practices", value: "best_practices" },
                        { label: "Webinar/Workshop", value: "webinar" },
                        { label: "Expert Advice", value: "expert_advice" },
                      ]}
                      name="contentType"
                      value={values?.contentType}
                      onChange={handleChange}
                      handleOnchange={(v) => {
                        console.log("Selected Content Type:", v);
                      }}
                    />
                    <ErrorMessage
                      name="contentType"
                      component="div"
                      className="error"
                    />
                  </div>
                </FormField>

                {/* Cash Crop Category */}
                <FormField
                  label="Cash Crop Category"
                  tooltip="Select related cash crop category"
                >
                  <div id="cashCropCategory" className="mb-4">
                    <Dropdown
                      options={[
                        { label: "Cocoa", value: "cocoa" },
                        { label: "Cashew", value: "cashew" },
                        { label: "Advanced", value: "oil_palm" },
                        { label: "Shea", value: "shea" },
                        { label: "Coffee", value: "coffee" },
                        { label: "Rubber", value: "rubber" },
                        { label: "Other", value: "other" },
                      ]}
                      name="cashCropCategory"
                      value={values?.cashCropCategory}
                      className={"mb-4"}
                      onChange={handleChange}
                      handleOnchange={(v) => {
                        console.log("Selected Cash Crop Category:", v);
                      }}
                    />
                    <ErrorMessage
                      name="cashCropCategory"
                      component="div"
                      className="error"
                    />
                  </div>
                </FormField>

                {/* Overview */}
                <FormField label="Overview" tooltip="Enter a brief summary">
                  <TextInput
                    name="overview"
                    type="text"
                    placeholder="Enter brief summary"
                    value={values.overview}
                    className={"mb-4"}
                    onChange={handleChange}
                  />
                  <ErrorMessage
                    name="overview"
                    component="div"
                    className="error"
                  />
                </FormField>

                {/* cource details*/}
                <FormField
                  label="Cource Details"
                  tooltip="Enter Cource Details"
                >
                  <TextInput
                    name="courseDetails"
                    type="textarea"
                    placeholder="Enter Cource Details"
                    value={values.courseDetails}
                    className={"mb-4"}
                    onChange={handleChange}
                  />
                  <ErrorMessage
                    name="courseDetails"
                    component="div"
                    className="error"
                  />
                </FormField>

                {/* Target Audience */}
                <FormField
                  label="Target Audience"
                  tooltip="Select the intended audience"
                >
                  <div id="targetAudience" className="mb-4">
                    <MultiSelect
                      value={values.targetAudience}
                      filter
                      onChange={(e) => {
                        console.log(e);
                        setFieldValue("targetAudience", e.target.value);
                      }}
                      options={[
                        {
                          label: "Beginner Farmers",
                          value: "beginner_farmers",
                        },
                        {
                          label: "Experienced Farmers",
                          value: "experienced_farmers",
                        },
                        {
                          label: "Agro-entrepreneurs",
                          value: "agro_entrepreneurs",
                        },
                        {
                          label: "Agricultural Researchers",
                          value: "agricultural_researchers",
                        },
                        { label: "Policymakers", value: "policymakers" },
                      ]}
                      optionLabel="label"
                      optionValue="value"
                      className="md:w-20rem"
                      placeholder="Select options"
                    />

                    <ErrorMessage
                      name="targetAudience"
                      component="div"
                      className="error"
                    />
                  </div>
                </FormField>

                {/* region */}
                {/* <FormField label="Region" tooltip="Select region">
                  <div id="region" className="mb-4">
                    <Dropdown
                      options={[
                        { label: "Greater Accra", value: "greater_accra" },
                        { label: "Ashanti", value: "ashanti" },
                        { label: "Western", value: "western" },
                        { label: "Eastern", value: "eastern" },
                        { label: "Northern", value: "northern" },
                      ]}
                      name="region"
                      className={"mb-4"}
                      value={values?.region}
                      onChange={handleChange}
                      handleOnchange={(v) => {
                        console.log("Selected region:", v);
                      }}
                    />
                    <ErrorMessage
                      name="region"
                      component="div"
                      className="error"
                    />
                  </div>
                </FormField> */}

                {/* Language */}
                <FormField label="Language" tooltip="Select language">
                  <div id="language" className="mb-4">
                    <Dropdown
                      options={[
                        { label: "English", value: "english" },
                        { label: "TWI", value: "twi" },
                        { label: "GA", value: "ga" },
                        { label: "EWE", value: "ewe" },
                      ]}
                      name="language"
                      className={"mb-4"}
                      value={values?.language}
                      onChange={handleChange}
                      handleOnchange={(v) => {
                        console.log("Selected Language:", v);
                      }}
                    />
                    <ErrorMessage
                      name="language"
                      component="div"
                      className="error"
                    />
                  </div>
                </FormField>

                {/* keywords */}
                <FormField
                  label="Keywords"
                  tooltip="Enter keywords separated by commas"
                >
                  <TextInput
                    name="keywords"
                    type="text"
                    placeholder="Enter keywords"
                    value={values.keywords.join(", ")} // Join the array into a comma-separated string
                    className={"mb-4"}
                    onChange={(e) => {
                      const input = e.target.value;
                      setFieldValue(
                        "keywords",
                        input.split(",").map((keyword) => keyword.trim()) // Split by commas and trim whitespace
                      );
                    }}
                  />
                  <ErrorMessage
                    name="keywords"
                    component="div"
                    className="error"
                  />
                </FormField>

                {/* image crop field  */}
                {/* <div style={{ padding: "20px" }}>
                  <h1>Image </h1>
                  <ImageCropper
                    aspect={4 / 3}
                    onImageCrop={handleCroppedImage}
                  />
                 
                </div> */}

                {/* thumbnail image input  */}
                <div className="flex">
                  <label className="block text-sm">Thumbnail</label>
                  <Tooltip text="add thumbnail for your cource" />
                </div>
                <div className="flex items-center justify-center">
                  <label
                    htmlFor="image"
                    className="w-60 h-60 shadow-lg border border-gray200 rounded-xl flex flex-col items-center justify-center cursor-pointer transition-all duration-200 hover:shadow-xl hover:border-gren400"
                  >
                    {!values.image && (
                      <IoAddCircleOutline className="text-6xl text-gray400 mb-2" />
                    )}

                    <input
                      type="file"
                      id="image"
                      accept="image/*"
                      name="image"
                      onChange={(e) => handleFileUpload(e, setFieldValue)}
                      style={{ display: "none" }}
                      required
                    />

                    {!values.image && (
                      <span className="text-gray600 font-semibold">
                        Add Image
                      </span>
                    )}

                    {currentItems?._id && typeof values.image !== "object" ? (
                      <LazyLoadImage
                        src={values.image}
                        alt="Uploaded"
                        loading="lazy"
                        effect="blur"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                        }}
                        className="rounded-xl"
                      />
                    ) : (
                      values.image && (
                        <ImagePreview file={values.image} id="image" />
                      )
                    )}
                  </label>
                </div>
                {/* video links */}
                <div className="mb-4">
                  <div className="flex">
                    <label className="block text-sm">Intro Video</label>
                    <Tooltip text="add only video links" />
                  </div>
                  <TextInput
                    name="introVideoLink"
                    type="text"
                    placeholder="Enter video URLs, one per line"
                    value={values.introVideoLink}
                    onChange={handleChange}
                    className="mb-2"
                    multiline
                  />
                  <ErrorMessage
                    name="videoLinks"
                    component="div"
                    className="error"
                  />
                  {values.videoLinks && (
                    <div className="mt-2">
                      <strong>Current Links</strong>
                      <span>{values.videoLinks}</span>
                    </div>
                  )}
                </div>

                {/* expert Contect   */}
                <FormField
                  label="Contect No."
                  tooltip="Enter expert's Contect number"
                >
                  <TextInput
                    name="expertContact"
                    type="number"
                    placeholder="Enter Contect number"
                    value={values.expertContact}
                    className={"mb-4"}
                    onChange={handleChange}
                  />
                  <ErrorMessage
                    name="expertContact"
                    component="div"
                    className="error"
                  />
                </FormField>

                {/* courseDetails
                <FormField
                      label="courseDetails"
                      tooltip="write a brief courseDetails of item"
                    >
                      <div id="courseDetails" className="mb-4">
                        <ReactQuill
                          theme="snow"
                          value={values.courseDetails}
                          onChange={(v) => setFieldValue("courseDetails", v)}
                        />
                        <ErrorMessage
                          name="courseDetails"
                          component="div"
                          className="error"
                        />
                      </div>
                    </FormField> */}

                {/* courseDetails */}
                {/* courseDetails.courseLevel */}
                <FormField label="Cource Level" tooltip="Select Cource Level">
                  <div id="courseLevel" className="mb-4">
                    <Dropdown
                      options={[
                        { label: "Beginner", value: "beginner" },
                        { label: "Intermediate", value: "intermediate" },
                        { label: "Advanced", value: "advanced" },
                      ]}
                      name="courseLevel"
                      value={values?.courseLevel}
                      className={"mb-4"}
                      onChange={handleChange}
                      handleOnchange={(v) => {
                        console.log("Selected course Level:", v);
                      }}
                    />
                    <ErrorMessage
                      name="courseLevel"
                      component="div"
                      className="error"
                    />
                  </div>
                </FormField>

                {/* syllabus list  */}
                <div className="mb-4">
                  {/* Header with Syllabus and Add Button */}
                  <div className="flex justify-between items-center mb-2">
                    <div className="flex items-center">
                      <label className="block text-sm mr-2">Syllabus</label>
                      <Tooltip text="Add lessons to the syllabus with title, duration and video link." />
                    </div>
                    <FieldArray
                      name="syllabusDetails.syllabus"
                      render={(arrayHelpers) => (
                        <button
                          type="button"
                          className="flex items-center gap-2 px-4 py-2 rounded-md bg-gren100 hover:bg-gren200"
                          onClick={() =>
                            arrayHelpers.push({
                              title: "",
                              duration: "",
                              video: "",
                              downloadableMaterials: [], // Initialize materials
                            })
                          }
                        >
                          <IoAddCircleOutline className="text-xl text-green500" />
                          <span className="text-sm text-green500">
                            Add Lesson
                          </span>
                        </button>
                      )}
                    />
                  </div>

                  {/* Lessons List */}
                  <FieldArray
                    name="syllabusDetails.syllabus"
                    render={(arrayHelpers) => (
                      <div>
                        {values.syllabusDetails.syllabus?.length > 0 &&
                          values.syllabusDetails.syllabus.map(
                            (lesson, index) => (
                              <div
                                key={index}
                                className="mb-4 border p-3 rounded-md bg-gray-50 flex flex-col gap-4"
                              >
                                {/* Lesson Title and Duration */}
                                <div className="flex gap-4">
                                  <TextInput
                                    name={`syllabusDetails.syllabus[${index}].title`}
                                    placeholder="Lesson Title"
                                    value={lesson.title}
                                    onChange={(e) =>
                                      setFieldValue(
                                        `syllabusDetails.syllabus[${index}].title`,
                                        e.target.value
                                      )
                                    }
                                  />
                                  <TextInput
                                    name={`syllabusDetails.syllabus[${index}].duration`}
                                    placeholder="Lesson Duration (e.g., 10 min)"
                                    value={lesson.duration}
                                    onChange={(e) =>
                                      setFieldValue(
                                        `syllabusDetails.syllabus[${index}].duration`,
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>

                                {/* Video Upload */}
                                <TextInput
                                  name={`syllabusDetails.syllabus[${index}].video`}
                                  placeholder="Video Link"
                                  value={lesson.video}
                                  onChange={(e) =>
                                    setFieldValue(
                                      `syllabusDetails.syllabus[${index}].video`,
                                      e.target.value
                                    )
                                  }
                                />

                                {/* Downloadable Materials Upload */}
                                <FieldArray
                                  name={`syllabusDetails.syllabus[${index}].downloadableMaterials`}
                                  render={(materialsHelpers) => (
                                    <div>
                                      <div className="flex justify-between items-center mb-2">
                                        <label className="block text-sm">
                                          Downloadable Materials
                                        </label>
                                        <button
                                          type="button"
                                          className="text-green500 text-sm"
                                          onClick={() =>
                                            materialsHelpers.push({
                                              file: null,
                                            })
                                          }
                                        >
                                          Add Material
                                        </button>
                                      </div>
                                      {lesson.downloadableMaterials?.length >
                                        0 &&
                                        lesson.downloadableMaterials.map(
                                          (material, materialIndex) => (
                                            <div
                                              key={materialIndex}
                                              className="flex gap-4 items-center"
                                            >
                                              <input
                                                type="file"
                                                name={`syllabusDetails.syllabus[${index}].downloadableMaterials[${materialIndex}].file`}
                                                className="file-input"
                                                onChange={(e) =>
                                                  setFieldValue(
                                                    `syllabusDetails.syllabus[${index}].downloadableMaterials[${materialIndex}].file`,
                                                    e.target.files[0]
                                                  )
                                                }
                                              />
                                              <button
                                                type="button"
                                                className="text-red600 text-sm"
                                                onClick={() =>
                                                  materialsHelpers.remove(
                                                    materialIndex
                                                  )
                                                }
                                              >
                                                Remove
                                              </button>
                                            </div>
                                          )
                                        )}
                                    </div>
                                  )}
                                />

                                {/* Remove Lesson Button */}
                                <button
                                  type="button"
                                  className="text-red600 mt-2"
                                  onClick={() => arrayHelpers.remove(index)}
                                >
                                  Remove Lesson
                                </button>
                              </div>
                            )
                          )}

                        {/* Error Message */}
                        <ErrorMessage
                          name="syllabusDetails.syllabus"
                          component="div"
                          className="error"
                        />
                      </div>
                    )}
                  />
                </div>

                {/* certification  */}
                <div>
                  <ToggleField
                    text={"are you provide certification ?"}
                    name="certification"
                    value={values.certification}
                    toggaleHandleChange={(e) => {
                      console.log("v", e.target.value);

                      setFieldValue("certification", e.target.value);
                    }}
                  />
                  <ErrorMessage
                    name="certification"
                    component="p"
                    className="error"
                  />
                </div>
              </SidebarField>
            </Form>
          )}
        </Formik>
      )}
    </div>
  );
};

export default Resources;
